import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ccmc-field-help-dialog',
  templateUrl: './field-help-dialog.component.html',
  styleUrls: ['./field-help-dialog.component.scss']
})
export class CCMCFieldHelpDialogComponent {
  public confirmMessage: string;

  constructor(
    public dialogRef: MatDialogRef<CCMCFieldHelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
